import {CONTENT_CATEGORY_PARAMETER, CONTENT_TYPE_TEXT} from '../../constants';

export default {
  id: 'NB_CLIENTS',
  title: 'Wie wird die Anzahl der Kunden, mit denen ich verbunden bin, berechnet?',
  description: '',
  categories: [CONTENT_CATEGORY_PARAMETER],
  contents: [{
    type: CONTENT_TYPE_TEXT,
    value: 'Als französischer Einleger, mit Ausnahme von Zweigniederlassungen, erlaubt Ihr Plan, dass Ihre Dokumente für eine bestimmte Anzahl von Kunden zugänglich sind, abhängig von Ihrem Plan.'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Die Anzahl der aktiven Kunden, mit denen Ihr Unternehmen verbunden ist, wird berechnet, indem die Anzahl der französischen Kunden auf Unternehmensebene (SIREN) und die Anzahl der nicht-französischen Kunden auf Niederlassungsebene addiert werden, wobei OFA und Partnerunternehmen von OFA (ILG, Actradis, Hiveo, Subclic) ausgeschlossen werden.'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Nehmen wir das Beispiel eines französischen Einlegers mit Ausnahme einer Zweigstelle, der seine Dokumente mit den folgenden aktiven Kunden teilt:'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '1. Französische Organisation 12345678900001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '2. Französische Organisation 12345678900002'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '3. Französische Organisation 11111111100001'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '4. Deutsche Organisation'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: '5. OFA'
  }, {
    type: CONTENT_TYPE_TEXT,
    value: 'Dieser Einleger steht in Verbindung mit 3 Kunden: Unternehmen 123456789, Unternehmen 111111111 und der deutschen Organisation'
  }]
};
